export default "__VITE_ASSET__HKkVB09Y__"